export async function apiErrorHandler(err) {
    if (err.response) {
        switch (err.response.status) {
            case 500:
                console.log(err);
                break;
            case 503:
                // re-reroute if 503 page
                return;
            case 404:
                // re-reroute if 404 page
                if (window.location.pathname !== '/login') {
                    window.location.href = `/login?returnUrl=${window.location.pathname}`;
                }
                return;
            case 401:
                if (window.location.pathname !== '/login') {
                    window.location.href = `/login?returnUrl=${window.location.pathname}`;
                }
                break;
            case 400:
                return err.response;
            default:
                break;
        }
        return err.response;
    }
    return new Error("unexpected error occurred!");
}

export function apiSuccessHandler(res) {
    return res;
}